import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  DropdownButton,
  ButtonGroup,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  Modal,
  ControlLabel,
  Alert,
  Checkbox,
  Tab,
  Tabs,
  Row,
  Col,
  Glyphicon,
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  getDealList,
  getOrderDeatil,
  getDealPending,
  getDealUpcoming,
  getDealPast,
  deleteDeal,
  confirmClose,
  uploadExternalVoucher,
  getDealSchedule,
  updateQuantity,
  getChildDeals,
  getDealContract,
} from "../../../redux/actions/dealActions";
import { transactionReport } from "../../../redux/actions/reportAction";
import {
  export_PurchaserList,
  export_PurchaserArchiveList,
  upload_TrackingNumbers,
} from "../../../redux/actions/voucherActions";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import Dialog from "react-bootstrap-dialog";
import "../../../style/listPage.scss";
import "react-responsive-tabs/styles.css";
import { aclUtil } from "../../util";
import { CSVLink } from "react-csv";
import moment from "moment";
import { getSiteCity } from "../../../redux/actions/frontActions";
import ReactHtmlParser from "react-html-parser";
const options = [25, 50, 75, 100, 125, 150, 175, 200];
const history = createBrowserHistory();
let merchantID = "";
let downloadData = [];
let isLoading = "false";
class DealtList extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    let csvData = [["VoucherNumber"], ["5555555555"]];
    let csvCodeData = [
      ["Voucher Number", "Tracking Number"],
      ["555-555-5555", "666666666"],
    ];
    super(props);
    this.state = {
      menuKey: "VIEW_OFFERS",
      dealList: [],
      dealPendingList: [],
      dealPastList: [],
      dealUpcomingList: [],
      dealScheduleList: [],
      totalRecords: 0,
      limit: 10,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      pendingCurrentPage: 1,
      pendingTotalRecords: 0,
      pendingPerPage: 0,
      pendingPageCount: 0,
      upcomingCurrentPage: 1,
      scheduleCurrentPage: 1,
      upcomingTotalRecords: 0,
      upcomingPerPage: 0,
      upcomingPageCount: 0,
      scheduleTotalRecords: 0,
      schedulePerPage: 0,
      schedulePageCount: 0,
      pastCurrentPage: 1,
      pastTotalRecords: 0,
      pastPerPage: 0,
      pastPageCount: 0,
      alertMessage: "",
      msgType: "success",
      skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      skuCodeOrderBy: "skuCode",
      executionDateTimeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIconUp: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIconSch: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIconPen: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIconPas: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextIconUp: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextIconSch: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextIconPen: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextIconPas: "glyphicon glyphicon-sort-by-attributes-alt",
      revenueIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      startDateTimeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      skuCodesortOrder: "DESC",
      executionDateTimesortOrder: "DESC",
      merchantNamesortOrder: "DESC",
      dealTextsortOrder: "DESC",
      startDateTimesortOrder: "DESC",
      path: ["Home", "Manage Deal List"],
      links: ["home", "dealList"],
      show: false,
      dealID: "",
      alertMessage: "",
      orderby: "",
      direction: "",
      viewOrders: "",
      viewMainOrders: "",
      offerName: "",
      merchantName: "",
      selectedOption: options[0],
      messageShow: false,
      contractID: "",
      loadVoucherStatus: false,
      selectedFile: "",
      csvData: csvData,
      csvCodeData: csvCodeData,
      uploadButton: "Upload File",
      updateqty: "",
      updatekey: "Update",
      updateOverallkey: "Update",
      cityList: "",
      default_city: "",
      downloadData: [],
      shippingEmail: 0,
      includeQr: "false",
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChangeExecution = this.handleChangeExecution.bind(this);

    // Alert
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.handleFormData = this.handleFormData.bind(this);
    this.viewOrders = this.viewOrders.bind(this);
  }

  handleClose() {
    this.setState({
      show: false,
      viewOrders: "",
      orderID: "",
    });
  }

  checkboxChange(evt) {
    this.setState({
      includeQr: evt.target.checked,
    });
  }

  handlePopupShow() {
    this.setState({
      show: true,
    });
  }

  viewOrders = (e) => {
    let id = e.target.attributes.getNamedItem("data-id").value;
    this.setState({ orderID: id });
    this.props.getOrderDeatil(id);
  };

  closeOffer = (e) => {
    let id = e.target.attributes.getNamedItem("data-id").value;
    this.dialog.show({
      body: "Are you sure you want to close this offer?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmClose(id);
        }),
      ],
    });
  };

  loadVoucher = (dealID, Status) => {
    isLoading = "true";
    this.props.getDealContract({ dealID: dealID });
    this.setState({ [Status]: true });
  };

  loadVoucherClose = (e) => {
    this.setState({
      ContractList: [],
      contractID: "",
      selectedFile: [],
      loadVoucherStatus: false,
      UploadedVoucherStatus: false,
      UploadCode: false,
      dealID: "",
      shippingEmail: 0,
    });
  };

  handleFormData(event) {
    this.setState({ selectedFile: event.target.files });
  }

  shippingEmail = (e) => {
    if (e.target.checked) {
      this.setState({ shippingEmail: 1 });
    } else {
      this.setState({ shippingEmail: 0 });
    }
  };

  uploadVoucher = (event) => {
    if (
      this.state.selectedFile &&
      this.state.selectedFile !== "" &&
      this.state.contractID
    ) {
      this.setState({ uploadButton: "Uploading.." });
      let images = this.state.selectedFile;
      const formData = new FormData();
      formData.append("contractID", this.state.contractID);
      formData.append("file", images[0]);
      formData.append("includeQr", this.state.includeQr);
      this.props.uploadExternalVoucher(formData);
      this.setState({
        includeQr: "false",
      });
    } else {
      alert("Please choose a file.");
    }
  };

  uploadCode = (event) => {
    if (
      this.state.selectedFile &&
      this.state.selectedFile !== "" &&
      this.state.dealID
    ) {
      this.setState({ uploadButton: "Uploading.." });
      let images = this.state.selectedFile;
      const formData = new FormData();
      formData.append("dealID", this.state.dealID);
      formData.append("file", images[0]);
      formData.append("shippingEmail", this.state.shippingEmail);
      this.props.upload_TrackingNumbers(formData);
    } else {
      alert("Please choose a file.");
    }
  };

  confirmClose = (id) => {
    this.props.confirmClose({ dealID: id });
  };

  handleDismiss() {
    this.setState({ messageShow: false });
  }

  handleShow() {
    this.setState({ messageShow: true });
  }

  handleSelect(eventKey, event) {
    this.setState({
      selectedOption: options[eventKey],
    });
    if (this.state.direction !== "" && this.state.orderby !== "") {
      this.props.getDealList({
        page: this.state.currentPage,
        limit: this.state.selectedOption,
        search: this.state.search,
        orderBy: this.state.orderby,
        direction: this.state.direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else {
      const postData = {
        page: this.state.currentPage,
        limit: this.state.selectedOption,
        search: this.state.search,
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealList(postData);
    }
  }

  confirmDelete = (dealID) => {
    this.props.deleteDeal(dealID);
  };

  handleChangeExecution(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSearch(e) {
    this.setState({ [e.target.name]: e.target.value });

    if (e.target.value.length > 1) {
      const postData = {
        page: "1",
        limit: this.state.limit,
        search: e.target.value,
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealList(postData);
      this.props.getDealPending(postData);
      this.props.getDealUpcoming(postData);
      this.props.getDealPast(postData);
      this.props.getDealSchedule(postData);
    } else {
      const postData = {
        page: "1",
        limit: this.state.limit,
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealList(postData);
      this.props.getDealPending(postData);
      this.props.getDealUpcoming(postData);
      this.props.getDealPast(postData);
      this.props.getDealSchedule(postData);
    }
  }

  sorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantName" && direction === "DESC") {
      this.setState({ merchantNamesortOrder: "ASC" });
      this.setState({
        merchantNameIconCur: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantNamesortOrder: "DESC" });
      this.setState({
        merchantNameIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "mainDealText" && direction === "DESC") {
      this.setState({ dealTextsortOrder: "ASC" });
      this.setState({
        dealTextIconCur: "glyphicon glyphicon-sort-by-attributes",
      });
    } else if (orderby === "mainDealText" && direction === "ASC") {
      this.setState({ dealTextsortOrder: "DESC" });
      this.setState({
        dealTextIconCur: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });

    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
      cityID: this.state.default_city,
    };
    this.props.getDealList(postData);
  }

  pendingSorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantName" && direction === "DESC") {
      this.setState({ merchantNamesortOrder: "ASC" });
      this.setState({
        merchantNameIconPen: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantNamesortOrder: "DESC" });
      this.setState({
        merchantNameIconPen: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "mainDealText" && direction === "DESC") {
      this.setState({ dealTextsortOrder: "ASC" });
      this.setState({
        dealTextIconPen: "glyphicon glyphicon-sort-by-attributes",
      });
    } else if (orderby === "mainDealText" && direction === "ASC") {
      this.setState({ dealTextsortOrder: "DESC" });
      this.setState({
        dealTextIconPen: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });

    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
      cityID: this.state.default_city,
    };
    this.props.getDealPending(postData);
  }

  upcomingSorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantName" && direction === "DESC") {
      this.setState({ merchantNamesortOrder: "ASC" });
      this.setState({
        merchantNameIconUp: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantNamesortOrder: "DESC" });
      this.setState({
        merchantNameIconUp: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "mainDealText" && direction === "DESC") {
      this.setState({ dealTextsortOrder: "ASC" });
      this.setState({
        dealTextIconUp: "glyphicon glyphicon-sort-by-attributes",
      });
    } else if (orderby === "mainDealText" && direction === "ASC") {
      this.setState({ dealTextsortOrder: "DESC" });
      this.setState({
        dealTextIconUp: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });

    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
      cityID: this.state.default_city,
    };
    this.props.getDealUpcoming(postData);
  }

  scheduleSorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantName" && direction === "DESC") {
      this.setState({ merchantNamesortOrder: "ASC" });
      this.setState({
        merchantNameIconSch: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantNamesortOrder: "DESC" });
      this.setState({
        merchantNameIconSch: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "mainDealText" && direction === "DESC") {
      this.setState({ dealTextsortOrder: "ASC" });
      this.setState({
        dealTextIconSch: "glyphicon glyphicon-sort-by-attributes",
      });
    } else if (orderby === "mainDealText" && direction === "ASC") {
      this.setState({ dealTextsortOrder: "DESC" });
      this.setState({
        dealTextIconSch: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });

    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
      cityID: this.state.default_city,
    };
    this.props.getDealSchedule(postData);
  }

  pastSorting(orderby, direction) {
    if (orderby === "skuCode" && direction === "DESC") {
      this.setState({ skuCodesortOrder: "ASC" });
      this.setState({ skuCodeIcon: "glyphicon glyphicon-sort-by-attributes" });
    } else {
      this.setState({ skuCodesortOrder: "DESC" });
      this.setState({
        skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "merchantName" && direction === "DESC") {
      this.setState({ merchantNamesortOrder: "ASC" });
      this.setState({
        merchantNameIconPas: "glyphicon glyphicon-sort-by-attributes",
      });
    } else {
      this.setState({ merchantNamesortOrder: "DESC" });
      this.setState({
        merchantNameIconPas: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    if (orderby === "mainDealText" && direction === "DESC") {
      this.setState({ dealTextsortOrder: "ASC" });
      this.setState({
        dealTextIconPas: "glyphicon glyphicon-sort-by-attributes",
      });
    } else if (orderby === "mainDealText" && direction === "ASC") {
      this.setState({ dealTextsortOrder: "DESC" });
      this.setState({
        dealTextIconPas: "glyphicon glyphicon-sort-by-attributes-alt",
      });
    }

    this.setState({ orderby: orderby });
    this.setState({ direction: direction });

    const postData = {
      page: this.state.currentPage,
      limit: this.state.limit,
      search: this.state.search,
      orderBy: orderby,
      direction: direction,
      merchantID: merchantID,
      cityID: this.state.default_city,
    };
    this.props.getDealPast(postData);
  }

  handlePageChange = (page) => {
    this.setState({
      currentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderby !== "") {
      this.props.getDealList({
        page: page,
        orderBy: this.state.orderby,
        direction: this.state.direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else if (this.state.search !== "") {
      this.props.getDealList({
        page: page,
        search: this.state.search,
        merchantID: merchantID,
      });
    } else {
      const postData = {
        page: page,
        limit: this.state.limit,
        search: this.state.search ? this.state.search : "",
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealList(postData);
    }
  };

  handlePendingPageChange = (page) => {
    this.setState({
      pendingCurrentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderby !== "") {
      this.props.getDealPending({
        page: page,
        orderBy: this.state.orderby,
        direction: this.state.direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else if (this.state.search !== "") {
      this.props.getDealPending({
        page: page,
        search: this.state.search,
        merchantID: merchantID,
      });
    } else {
      const postData = {
        page: page,
        limit: this.state.limit,
        search: this.state.search ? this.state.search : "",
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealPending(postData);
    }
  };

  handleUpcomingPageChange = (page) => {
    this.setState({
      upcomingCurrentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderby !== "") {
      this.props.getDealUpcoming({
        page: page,
        orderBy: this.state.orderby,
        direction: this.state.direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else if (this.state.search !== "") {
      this.props.getDealUpcoming({
        page: page,
        search: this.state.search,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else {
      const postData = {
        page: page,
        limit: this.state.limit,
        search: this.state.search ? this.state.search : "",
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealUpcoming(postData);
    }
  };

  handleSchedulePageChange = (page) => {
    this.setState({
      scheduleCurrentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderby !== "") {
      this.props.getDealSchedule({
        page: page,
        orderBy: this.state.orderby,
        direction: this.state.direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else if (this.state.search !== "") {
      this.props.getDealSchedule({
        page: page,
        search: this.state.search,
        merchantID: merchantID,
      });
    } else {
      const postData = {
        page: page,
        limit: this.state.limit,
        search: this.state.search ? this.state.search : "",
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealSchedule(postData);
    }
  };

  handlePastPageChange = (page) => {
    this.setState({
      pastCurrentPage: page,
    });
    if (this.state.direction !== "" && this.state.orderby !== "") {
      this.props.getDealPast({
        page: page,
        orderBy: this.state.orderby,
        direction: this.state.direction,
        merchantID: merchantID,
        cityID: this.state.default_city,
      });
    } else if (this.state.search !== "") {
      this.props.getDealPast({
        page: page,
        search: this.state.search,
        merchantID: merchantID,
      });
    } else {
      const postData = {
        page: page,
        limit: this.state.limit,
        search: this.state.search ? this.state.search : "",
        merchantID: merchantID,
        cityID: this.state.default_city,
      };
      this.props.getDealPast(postData);
    }
  };

 // componentDidMount() {}

  componentWillMount() {
    isLoading = "true";
    if (this.props.match.params && this.props.match.params.merchantID) {
      merchantID =
        this.props.match.params && this.props.match.params.merchantID
          ? this.props.match.params.merchantID
          : "";

    } else {
      merchantID = this.props.merchantID;
    }
     this.setState({
          merchantID: merchantID,
        });

    this.props.clearAlert();
    this.handleDismiss();

    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));
    let default_city;
    if (siteData) {
      if (siteData.default_city) {
        default_city = siteData.default_city;
        this.setState({
          default_city: siteData.default_city,
        });
      }
    }
    if (localStorage.getItem("userTypeName") == "salesmanager") {
      this.props.getSiteCity({
        sales_manager_id: localStorage.getItem("user_sec_id"),
      });
    } else {
      this.props.getSiteCity();
    }
    this.props.getDealList({
      page: 1,
      merchantID: merchantID,
      cityID: default_city,
    });
    // this.props.getDealPending({
    //   page: 1,
    //   merchantID: merchantID,
    //   cityID: default_city,
    // });
    // this.props.getDealUpcoming({
    //   page: 1,
    //   merchantID: merchantID,
    //   cityID: default_city,
    // });
    //this.props.getDealPast({page:1, merchantID: merchantID, cityID: default_city});
    // this.props.getDealSchedule({
    //   page: 1,
    //   merchantID: merchantID,
    //   cityID: default_city,
    // });
  }

  setDefaultCity = (e) => {
    let default_city = e.target.value;
    this.props.getDealList({
      page: 1,
      merchantID: merchantID,
      cityID: default_city,
    });
    this.props.getDealPending({
      page: 1,
      merchantID: merchantID,
      cityID: default_city,
    });
    this.props.getDealUpcoming({
      page: 1,
      merchantID: merchantID,
      cityID: default_city,
    });
    this.props.getDealPast({page:1, merchantID: merchantID, cityID: default_city});

    this.setState({ [e.target.name]: e.target.value });
  };

  componentWillReceiveProps(nextProps) {
    if (
      !aclUtil.isPrimaryMenuAccessible(this.state.menuKey) &&
      localStorage.getItem("userTypeName") !== "merchant"
    ) {
      this.context.router.history.push("/restrictedAccess");
    }
    if (this.props.dealList !== nextProps.dealList) {
      if (nextProps.dealList != "") {
        isLoading = "false";
        const setPageCount =
          nextProps.dealList.total / nextProps.dealList.per_page;
        this.setState({
          dealList: nextProps.dealList.data,
          totalRecords: nextProps.dealList.total,
          perPage: nextProps.dealList.per_page,
          pageCount: 5,
        });
      } else {
        isLoading = "false";
        this.setState({
          dealList: "",
          totalRecords: 0,
          perPage: "",
          pageCount: 0,
        });
      }
    }

    if (this.props.transaction !== nextProps.transaction) {
      if (nextProps.transaction) {
        this.handleExport(
          nextProps.transaction.data.data,
          nextProps.transaction.merchantName,
          nextProps.transaction.offerName
        );
      }
    }

    if (this.props.exportList !== nextProps.exportList) {
      if (nextProps.exportList) {
        this.handleBuyerExport(
          nextProps.exportList.data,
          nextProps.exportList.shipable,
          nextProps.exportList.willCall,
          nextProps.exportList.merchantName,
          nextProps.exportList.offerName
        );
      }
    }

    if (this.props.orderData != nextProps.orderData) {
      if (nextProps.orderData) {
        this.setState({ viewOrders: nextProps.orderData });
        if (nextProps.orderData[0]) {
          this.setState({ viewMainOrders: nextProps.orderData[0] });
        }
        this.handlePopupShow();
      }
    }

    if (this.props.dealPendingList !== nextProps.dealPendingList) {
      if (nextProps.dealPendingList != "") {
        const setPageCount =
          nextProps.dealPendingList.total / nextProps.dealPendingList.per_page;
        this.setState({
          dealPendingList: nextProps.dealPendingList.data,
          pendingTotalRecords: nextProps.dealPendingList.total,
          pendingPerPage: nextProps.dealPendingList.per_page,
          pendingPageCount: 5,
        });
      } else {
        this.setState({
          dealPendingList: "",
          pendingTotalRecords: 0,
          pendingPerPage: 0,
          pendingPageCount: 0,
        });
      }
    }

    if (this.props.dealPastList !== nextProps.dealPastList) {
      if (nextProps.dealPastList != "") {
        const setPageCount =
          nextProps.dealPastList.total / nextProps.dealPastList.per_page;
        this.setState({
          dealPastList: nextProps.dealPastList.data,
          pastTotalRecords: nextProps.dealPastList.total,
          pastPerPage: nextProps.dealPastList.per_page,
          pastPageCount: 5,
        });
      } else {
        this.setState({
          dealPastList: "",
          pastTotalRecords: 0,
          pastPerPage: 0,
          pastPageCount: 0,
        });
      }
    }

    if (this.props.dealUpcomingList !== nextProps.dealUpcomingList) {
      if (nextProps.dealUpcomingList != "") {
        const setPageCount =
          nextProps.dealUpcomingList.total /
          nextProps.dealUpcomingList.per_page;
        this.setState({
          dealUpcomingList: nextProps.dealUpcomingList.data,
          upcomingTotalRecords: nextProps.dealUpcomingList.total,
          upcomingPerPage: nextProps.dealUpcomingList.per_page,
          upcomingPageCount: 5,
        });
      } else {
        this.setState({
          dealUpcomingList: "",
          upcomingTotalRecords: 0,
          upcomingPerPage: 0,
          upcomingPageCount: 0,
        });
      }
    }

    if (this.props.dealScheduleList !== nextProps.dealScheduleList) {
      if (nextProps.dealScheduleList != "") {
        const setPageCount =
          nextProps.dealScheduleList.total /
          nextProps.dealScheduleList.per_page;
        this.setState({
          dealScheduleList: nextProps.dealScheduleList.data,
          scheduleTotalRecords: nextProps.dealScheduleList.total,
          schedulePerPage: nextProps.dealScheduleList.per_page,
          schedulePageCount: 5,
        });
      } else {
        this.setState({
          dealScheduleList: "",
          scheduleTotalRecords: 0,
          schedulePerPage: 0,
          schedulePageCount: 0,
        });
      }
    }

    if (this.props.dealDeleted !== nextProps.dealDeleted) {
      if (!isEmpty(nextProps.dealDeleted)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.dealDeleted.message);
        this.handlePageChange(this.state.currentPage);
      } else {
        this.props.clearAlert();
      }
    }
    if (this.props.quantityStatus !== nextProps.quantityStatus) {
      if (!isEmpty(nextProps.quantityStatus)) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.quantityStatus.message);
        this.props.getOrderDeatil(this.state.orderID);
        this.handlePageChange(this.state.currentPage);
        this.setState({ updateqty: "", updatekey: "Update" });
        this.setState({ updateOverallqty: "", updateOverallkey: "Update" });
      } else {
        this.props.clearAlert();
      }
    }
    if (this.props.closeStatus !== nextProps.closeStatus) {
      if (nextProps.closeStatus) {
        isLoading = "true";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.closeStatus.message);
        this.handlePageChange(this.state.currentPage);
        this.props.getDealList({
          page: 1,
          merchantID: merchantID,
          cityID: this.state.default_city,
        });
        this.props.getDealPending({
          page: 1,
          merchantID: merchantID,
          cityID: this.state.default_city,
        });
        this.props.getDealUpcoming({
          page: 1,
          merchantID: merchantID,
          cityID: this.state.default_city,
        });
        this.props.getDealPast({
          page: 1,
          merchantID: merchantID,
          cityID: this.state.default_city,
        });
        this.props.getDealSchedule({
          page: 1,
          merchantID: merchantID,
          cityID: this.state.default_city,
        });
      }
    }

    if (this.props.voucherStatus !== nextProps.voucherStatus) {
      if (nextProps.voucherStatus) {
        this.props.clearAlert();
        this.handleShow();
        if (nextProps.voucherStatus.response == "success") {
          this.loadVoucherClose();
          this.props.renderAlert("success", nextProps.voucherStatus.message);
        } else {
          this.props.renderAlert("danger", nextProps.voucherStatus.message);
        }
        this.handlePageChange(this.state.currentPage);
        this.setState({ uploadButton: "Upload File" });
      }
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        this.setState({ uploadButton: "Upload File" });
      }
    }

    if (this.props.dealError !== nextProps.dealError) {
      if (nextProps.dealError) {
        this.props.clearAlert();
        this.handleShow();
        this.loadVoucherClose();
        this.props.renderAlert("warning", nextProps.dealError);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }

    if (this.props.cityList != nextProps.cityList) {
      if (nextProps.cityList) {
        this.setState({ cityList: nextProps.cityList.data });
      }
    }
    if (this.props.ChildDeals != nextProps.ChildDeals) {
      this.setState({ dealShow: true, child_deals: nextProps.ChildDeals });
    }

    if (this.props.ContractList != nextProps.ContractList) {
      isLoading = "false";
      this.setState({
        ContractList: nextProps.ContractList,
        contractID: nextProps.ContractList[0].contractID,
        dealID: nextProps.ContractList[0].dealID,
      });
    }
    if (this.props.tracknigResponse !== nextProps.tracknigResponse) {
      if (nextProps.tracknigResponse) {
        this.props.clearAlert();
        this.handleShow();
        if (nextProps.tracknigResponse.response == "success") {
          this.props.renderAlert("success", nextProps.tracknigResponse.message);
        } else {
          this.props.renderAlert("danger", nextProps.tracknigResponse.message);
        }
        this.loadVoucherClose();
        this.handlePageChange(this.state.currentPage);
        this.setState({ uploadButton: "Upload File" });
      }
    }
  }

  attribute(attributes) {
    let attr = "";
    if (attributes && attributes != "" && attributes !== null) {
      return attributes
        .map((value, index) => {
          return Object.keys(value)
            .map(function (k, i) {
              return k + " : " + value[k];
            })
            .join(" :: ");
        })
        .join(" || ");
    }
    return "";
  }

  handleBuyerExport = (data, shipable, willCall, merchantName, offerName) => {
    let headerarray = [];
    let dataarray = [];
    headerarray = [
      "Voucher Number",
      "Offer ID",
      "Offer Name",
      "Merchant Name",
      "First Name",
      "Last Name",
      "Email",
      "Phone",
      "Voucher Status",
      "Order Date",
      "Voucher Redemption Date",
    ];
    if (shipable != "0") {
      headerarray = [
        ...headerarray,
        "Tracking Number",
        "Tracking Uploaded Date",
        "Shipping to Admin",
        "Shipping to Merchant",
      ];
    }

    if (willCall != "0") {
      headerarray = [
        ...headerarray,
        "Recipient First Name",
        "Recipient Last Name",
      ];
    }
    if (shipable != "0") {
      headerarray = [
        ...headerarray,
        "Shipping First Name",
        "Shipping Last Name",
        "Shipping Address",
        "Shipping City",
        "Shipping State",
        "Shipping Zip",
        "Gift Recipient Name",
        "Gift Recipient Address",
        "Gift Recipient City",
        "Gift Recipient State",
        "Gift Recipient Zip",
      ];
    }

    headerarray = [...headerarray, "Attribute"];
    headerarray = [...headerarray, "Customer Spend Amount"];

    downloadData = [headerarray];
    {
      data &&
        data.map((data, keyIndex) => {
          if (data) {
            dataarray = [
              data.VoucherNumber,
              data.OfferID,
              data.dealText,
              data.merchantName,
              data.FirstName,
              data.LastName,
              data.Email,
              data.Phone,
              data.Status,
              data.OrderDate,
              data.redeemed_at,
            ];

            if (shipable != "0") {
              dataarray = [
                ...dataarray,
                data.trackingNumber,
                data.trackingUploadedAt,
                data.shipping_to_admin,
                data.shipping_to_merchant,
              ];
            }

            if (willCall != "0") {
              dataarray = [
                ...dataarray,
                data.pickupFirstName,
                data.pickupLastName,
              ];
            }

            if (shipable != "0") {
              var ship_text = data.shipping_address,
                regex = /([A-Za-z]"[A-Za-z])/gi,
                result,
                index;
              if (ship_text && ship_text !== null) {
                while ((result = regex.exec(ship_text))) {
                  index = ship_text.search(regex);
                  ship_text =
                    ship_text.substr(0, index) +
                    "'" +
                    ship_text.substr(index + 2);
                }
                var shipping_address = JSON.parse(ship_text);
                dataarray = [
                  ...dataarray,
                  shipping_address
                    ? shipping_address.first_name &&
                      shipping_address.first_name !== null
                      ? shipping_address.first_name
                      : ""
                    : "",
                  shipping_address
                    ? shipping_address.last_name &&
                      shipping_address.last_name !== null
                      ? shipping_address.last_name
                      : ""
                    : "",
                  shipping_address
                    ? (shipping_address.line_1 &&
                      shipping_address.line_1 !== null
                        ? shipping_address.line_1
                        : "") +
                      (shipping_address.line_2 &&
                      shipping_address.line_2 !== null
                        ? "," + shipping_address.line_2
                        : "") +
                      (shipping_address.address1 &&
                      shipping_address.address1 !== null
                        ? shipping_address.address1
                        : "")
                    : "",
                  shipping_address
                    ? shipping_address.city && shipping_address.city !== null
                      ? shipping_address.city
                      : ""
                    : "",
                  shipping_address
                    ? shipping_address.state && shipping_address.state !== null
                      ? shipping_address.state
                      : ""
                    : "",
                  shipping_address
                    ? shipping_address.zip && shipping_address.zip !== null
                      ? shipping_address.zip
                      : ""
                    : "",
                ];
              }
              var recipient_text = data.recipientAddress,
                regex = /([A-Za-z]"[A-Za-z])/gi,
                result,
                index;
              if (recipient_text && recipient_text !== null) {
                while ((result = regex.exec(recipient_text))) {
                  index = recipient_text.search(regex);
                  recipient_text =
                    recipient_text.substr(0, index) +
                    "'" +
                    recipient_text.substr(index + 2);
                }
                var recipient_address = JSON.parse(recipient_text);
                dataarray = [
                  ...dataarray,
                  data.recipientName ? data.recipientName : "",
                  recipient_address
                    ? recipient_address.address
                      ? recipient_address.address
                      : (recipient_address.line_1
                          ? recipient_address.line_1
                          : "") +
                        (recipient_address.line_2
                          ? "," + recipient_address.line_2
                          : "")
                    : "",
                  recipient_address
                    ? recipient_address.city && recipient_address.city !== null
                      ? recipient_address.city
                      : ""
                    : "",
                  recipient_address
                    ? recipient_address.state &&
                      recipient_address.state !== null
                      ? recipient_address.state
                      : ""
                    : "",
                  recipient_address
                    ? recipient_address.zip && recipient_address.zip !== null
                      ? recipient_address.zip
                      : ""
                    : "",
                ];
              } else {
                dataarray = [...dataarray, "", "", "", "", ""];
              }
            }
            dataarray = [...dataarray, this.attribute(data.attribute)];
            dataarray = [...dataarray, data.customerSpendAmt];
            downloadData.push(dataarray);
          }
        });
    }
    this.setState({
      downloadData: downloadData,
      offerName: offerName,
      merchantName: merchantName,
    });
  };


  handleExport = (data, merchantName, offerName) => {
    downloadData = [
      [
        // "#",
        "Proposal Type",
        "Offer ID",
        "Sold Out",
        "Offer Name",
        "Original Price",
        "Offer Price",
        "Launch Date",
        "End Date",
        "Manually Generated",
        "City",
        "State",
        "Country",
        "Customer First Name",
        "Customer Last Name",
        "Customer Email",
        "Customer Phone",
        "Customer Address",
        "Transaction ID",
        "Transaction Date",
        "Transaction Time",
        "Currency",
        "Credit Card Sale",
        "User Credits Used ",
        "Promo Code Credit Used",
        "Gross Sale",
        "Shipping to Site",
        "Shipping to Merchant",
        "Tax Percentage",
        "Tax Amount",
        "Credit Card %",
        "Credit Card Fee",
        "Refunds",
        "Adjusted Gross",
        "Site Commission",
        "Site Commission %",
        "Merchant Remittance",
        "Merchant Remittance %",
        "Net Payout To Merchant",
        "Final Merchant Payout ",
        "Net To Site",
        "Payment Method",
        "Sales Rep Full Name",
        "Payment Status",
        "Pricing Option Deal Title",
        "Offer Option",
        "Merchant ID",
        "Merchant Email",
        "Phone",
        "Vouchers",
        "Gross Billing",
        "Payvibe Commission",
        "Payvibe Commission %",
        "Tracking Info Date/Time",
        "Additional Notes",
        "Categories",
        "Billing Address",
        "Billing City",
        "Billing State",
        "Billing Zip",
        "Shipping Address",
        "Shipping City",
        "Shipping State",
        "Shipping Zip",
        "Charity Name",
      ],
    ];

    {
      data &&
        data.map((tran, index) =>
          downloadData.push([
            tran.proposal_type,
            tran.offer_id,
            tran.quantity_remaining <= 0 ? "Sold Out" : "",
            tran.offer_name,
            tran.original_price,
            tran.offer_price,
            tran.launch_date,
            tran.end_date,
            tran.is_manually_generated == "1" ? "Yes" : "No",
            tran.city_name,
            tran.state_name,
            tran.country_name,
            tran.customer_first_name,
            tran.customer_last_name,
            tran.customer_email,
            tran.customer_phone,
            tran.customer_address,
            tran.transaction_id,
            tran.transaction_date,
            tran.transaction_time,
            tran.currency,
            tran.credit_card_sale,
            tran.user_credit_used,
            tran.promo_credit_used,
            tran.gross_sale,
            tran.shipping_to_site,
            tran.shipping_to_merchant,
            tran.tax_percentage,
            tran.tax_amount,
            tran.credit_card_percentage,
            tran.credit_card_fee,
            tran.refund_amount,
            tran.adjusted_gross_sale,
            tran.site_commission,
            tran.site_commission_percentage,
            tran.merchant_remittance,
            tran.merchant_commission_percentage,
            tran.net_payout_to_merchant,
            tran.final_merchant_payout,
            tran.net_to_site,
            tran.payment_method,
            tran.sales_representative_fullname,
            tran.payment_status,
            "",
            JSON.stringify(tran.offer_options).replace(/,/g, "||"),
            tran.merchant_id,
            tran.merchant_email,
            tran.merchant_phone,
            tran.vouchers,
            tran.gross_billing,
            "",
            "",
            tran.tracking_info_datetime,
            tran.additional_notes,
            tran.categories,
            JSON.parse(tran.billing_address).line_2 !== null
              ? JSON.parse(tran.billing_address).line_1 +
                "," +
                JSON.parse(tran.billing_address).line_2
              : JSON.parse(tran.billing_address).line_1,
            JSON.parse(tran.billing_address).city,
            JSON.parse(tran.billing_address).state,
            JSON.parse(tran.billing_address).zip,
            JSON.parse(tran.shipping_address).line_2 !== null
              ? JSON.parse(tran.shipping_address).line_1 +
                "," +
                JSON.parse(tran.shipping_address).line_2
              : JSON.parse(tran.shipping_address).line_1,
            JSON.parse(tran.shipping_address).city,
            JSON.parse(tran.shipping_address).state,
            JSON.parse(tran.shipping_address).zip,
            tran.charity_name,
          ])
        );
    }

    this.setState({
      downloadData: downloadData,
      offerName: offerName,
      merchantName: merchantName,
    });
    // document.getElementById("downloadData").click();;
  };

  componentDidUpdate() {
    if (!isEmpty(this.state.downloadData)) {
      document.getElementById("downloadData").click();
      this.setState({ downloadData: [], offerName: "", merchantName: "" });
    }
  }

  handleDelete = (dealID) => {
    this.dialog.show({
      body: "Are you sure you want to delete this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(dealID);
        }),
      ],
    });
  };

  handleTabs = (data) => {
    this.setState({
      skuCodeIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      merchantNameIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      dealTextIcon: "glyphicon glyphicon-sort-by-attributes-alt",
    });
    
    if (data === 1) {

      this.props.getDealList({
        page: 1,
        merchantID: this.state.merchantID,
        cityID: this.state.default_city,
      });
    }

    if (data === 4) {
      this.props.getDealPending({
        page: 1,
        merchantID: this.state.merchantID,
        cityID: this.state.default_city,
      });
    }
    if (data === 2) {
      this.props.getDealUpcoming({
        page: 1,
        merchantID: this.state.merchantID,
        cityID: this.state.default_city,
      });
    }
    if (data === 6) {
      this.props.getDealSchedule({
        page: 1,
        merchantID: this.state.merchantID,
        cityID: this.state.default_city,
      });
    }
    if (data === 5) {
      this.props.getDealPast({
        page: 1,
        merchantID: this.state.merchantID,
        cityID: this.state.default_city,
      });
    }
  };
  newWindow = (dealID, url) => {
    window.open("/" + url + dealID, "_blank");
  };

  viewAllDeals = (dealID) => {
    this.props.getChildDeals({
      dealID: dealID,
      cityID: this.state.default_city,
    });
    //this.setState({dealShow: true, child_deals: JSON.parse(child_deals)});
  };

  viewExportOrders = (dealID) => {
    this.props.transactionReport({ admin_deal_id: dealID });
  };

  viewOffers = (dealID) => {
    this.props.export_PurchaserList({ admin_deal_id: dealID });
  };

  handleDealClose = () => {
    this.setState({ dealShow: false, child_deals: "" });
  };
   viewArchiveOffers = (dealID) => {
      this.props.export_PurchaserArchiveList({admin_deal_id: dealID});
    };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value, quantityError: "" });
  };

  setQuantity = (e) => {
    this.setState({
      quantityID: e.target.attributes.getNamedItem("data-id").value,
      updateqty: "",
    });
  };

  setOverallQuantity = (e) => {
    this.setState({
      OverallquantityID: e.target.attributes.getNamedItem("data-id").value,
      updateOverallqty: "",
    });
  };

  checkQuantityValidation = (type) => {
    let status = true;
    let orders = this.state.viewOrders;
    let max_overall = parseInt(orders[0].max_overall);
    let checkMaxOverall = true;
    this.state.viewOrders.map((data, index) => {
      if (data.total == "") {
        checkMaxOverall = false;
      }
    });
    let sumArray = 0;
    let total =
      type == "available" ? this.state.updateqty : this.state.updateOverallqty;
    this.state.viewOrders.map((data, index) => {
      if (data.total != "") {
        sumArray = parseInt(sumArray) + parseInt(data.total);
      }
    });

    if (orders.length == 1) {
      if (type == "available") {
        sumArray = parseInt(total) + parseInt(sumArray);
      } else {
        max_overall = parseInt(max_overall) + parseInt(total);
      }
      if (type == "available") {
        if (max_overall != "" || max_overall != null) {
          if (max_overall != sumArray) {
            alert(
              "Overall quantity and total available quantity must be equal."
            );
            status = false;
          }
        }
      }
    } else {
      if (type == "available") {
        sumArray = parseInt(total) + parseInt(sumArray);
      } else {
        max_overall = parseInt(max_overall) + parseInt(total);
      }
      if (checkMaxOverall == false) {
        if (max_overall < sumArray) {
          alert(
            "Overall quantity must be greater than or equal to total available quantity."
          );
          status = false;
        }
      } else {
        if (max_overall == sumArray) {
          alert("Overall quantity and total available quantity must be equal.");
          status = false;
        }
      }
    }

    return status;
  };

  updateQty = (e) => {
    let status = this.checkQuantityValidation("available");
    if (status == true) {
      if (this.state.updateqty) {
        this.setState({ updatekey: "Updating..." });
        this.props.updateQuantity({
          dealID: this.state.quantityID,
          quantity: this.state.updateqty,
        });
      } else {
        this.setState({ updateqtyError: "red" });
      }
    }
  };

  updateOverallQty = (e) => {
    let status = this.checkQuantityValidation("overall");
    if (status == true) {
      if (this.state.updateOverallqty) {
        this.setState({ updateOverallkey: "Updating..." });
        this.props.updateQuantity({
          dealID: this.state.OverallquantityID,
          max_overall_quantity: this.state.updateOverallqty,
        });
      } else {
        this.setState({ updateOverallqtyError: "red" });
      }
    }
  };

  cancelQuantity = (e) => {
    this.setState({ quantityID: "", quantity: "" });
  };

  cancelOverallQuantity = (e) => {
    this.setState({ OverallquantityID: "", max_overall_quantity: "" });
  };

  render() {
    const { path } = this.state;
    const {
      currentPage,
      totalRecords,
      perPage,
      pageCount,
      pendingCurrentPage,
      pendingTotalRecords,
      pendingPerPage,
      pendingPageCount,
      upcomingCurrentPage,
      upcomingTotalRecords,
      upcomingPerPage,
      upcomingPageCount,
      pastCurrentPage,
      pastTotalRecords,
      pastPerPage,
      pastPageCount,
      scheduleTotalRecords,
      schedulePerPage,
      schedulePageCount,
      scheduleCurrentPage,
    } = this.state;
    let dealRow,
      dealRowPending,
      dealRowPast,
      dealRowUnschedule,
      dealRowSchedule;

    if (!isEmpty(this.state.dealPastList)) {
      dealRowPast = this.state.dealPastList.map((deal, index) => (
        <tr key={Math.random()}>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.deal_id}</td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>{deal.quantity_remaining <= 0 ? "Sold Out" : ""}</td>
          )}
          <td>{moment(deal.executedOn).format("ll hh:mm A")}</td>
          <td>{deal.merchantName}</td>
          <td>{ReactHtmlParser(deal.dealText)}</td>
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td className="text-danger">
              <b>
                {localStorage.getItem("symbol")}
                {deal.revenue ? deal.revenue : "0.00"}
              </b>
            </td>
          )}
          <td>
            {!isEmpty(deal.startDateTime)
              ? moment(deal.startDateTime).format("ll hh:mm A") +
                " - " +
                moment(deal.expiryDateTime).format("ll hh:mm A")
              : "Not Scheduled"}
          </td>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.purchase_count}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.quantity_remaining}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.voucher_expiration_date}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              {localStorage.getItem("symbol")}
              {parseFloat(deal.merchant_payables).toFixed(2)}
            </td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL("EDIT_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/editDeal/${deal.dealID}`
                        )
                      }
                    >
                      Edit Deal
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/edit`
                        )
                      }
                    >
                      Edit Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.deal_id + "/preview",
                      "deals-detail/"
                    )}
                  >
                    Preview Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.dealID,
                      "samplevoucher/"
                    )}
                  >
                    Preview Voucher
                  </MenuItem>
                  {aclUtil.checkACL("VIEW_LEAD") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.dealID}
                      onClick={this.viewOrders}
                    >
                      Inventory
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone`
                        )
                      }
                    >
                      Clone Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT_NON_EXECUTED") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone-non-execeuted`
                        )
                      }
                    >
                      Clone Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewExportOrders.bind(this, deal.dealID)}
                  >
                    Transactions
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewOffers.bind(this, deal.dealID)}
                  >
                    Deal Buyers
                  </MenuItem>
                  <MenuItem eventKey={Math.random()} onClick={this.viewArchiveOffers.bind(this, deal.dealID)}>Archive Deal Buyers</MenuItem>
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.contractID}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "loadVoucherStatus"
                      )}
                    >
                      Load Voucher
                    </MenuItem>
                  )}
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={
                        this.loadVoucher.bind(
                          this,
                          deal.deal_id,
                          "UploadedVoucherStatus"
                        ) /*this.newWindow.bind(this, deal.dealID, 'uploaded-vouchers/')*/
                      }
                    >
                      Uploaded Voucher
                    </MenuItem>
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") && deal.shipable == "1" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "UploadCode"
                      )}
                    >
                      Upload Tracking Code
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {aclUtil.checkACL("DEAL_BUYER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.viewOffers.bind(this, deal.dealID)}
                    >
                      Deal Buyers
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
        </tr>
      ));
    }

    if (!isEmpty(this.state.dealUpcomingList)) {
      dealRowUnschedule = this.state.dealUpcomingList.map((deal, index) => (
        <tr key={Math.random()}>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.deal_id}</td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>{deal.quantity_remaining <= 0 ? "Sold Out" : ""}</td>
          )}
          <td>{moment(deal.executedOn).format("ll hh:mm A")}</td>
          <td>{deal.merchantName}</td>
          <td>{ReactHtmlParser(deal.dealText)}</td>
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td className="text-danger">
              <b>
                {localStorage.getItem("symbol")}
                {deal.revenue ? deal.revenue : "0.00"}
              </b>
            </td>
          )}
          <td>
            {!isEmpty(deal.startDateTime)
              ? moment(deal.startDateTime).format("ll hh:mm A") +
                " - " +
                moment(deal.expiryDateTime).format("ll hh:mm A")
              : "Not Scheduled"}
          </td>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.purchase_count}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.quantity_remaining}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.voucher_expiration_date}</td>
          )}

          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              {localStorage.getItem("symbol")}
              {parseFloat(deal.merchant_payables).toFixed(2)}
            </td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL("EDIT_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/editDeal/${deal.dealID}`
                        )
                      }
                    >
                      Edit Deal
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/edit`
                        )
                      }
                    >
                      Edit Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.deal_id + "/preview",
                      "deals-detail/"
                    )}
                  >
                    Preview Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.dealID,
                      "samplevoucher/"
                    )}
                  >
                    Preview Voucher
                  </MenuItem>
                  {aclUtil.checkACL("VIEW_LEAD") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.dealID}
                      onClick={this.viewOrders}
                    >
                      Inventory
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone`
                        )
                      }
                    >
                      Clone Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT_NON_EXECUTED") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone-non-execeuted`
                        )
                      }
                    >
                      Clone Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLOSE_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.dealID}
                      onClick={this.closeOffer}
                    >
                      Close Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.contractID}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "loadVoucherStatus"
                      )}
                    >
                      Load Voucher
                    </MenuItem>
                  )}
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={
                        this.loadVoucher.bind(
                          this,
                          deal.deal_id,
                          "UploadedVoucherStatus"
                        ) /*this.newWindow.bind(this, deal.dealID, 'uploaded-vouchers/')*/
                      }
                    >
                      Uploaded Voucher
                    </MenuItem>
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") && deal.shipable == "1" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "UploadCode"
                      )}
                    >
                      Upload Tracking Code
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {aclUtil.checkACL("DEAL_BUYER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.viewOffers.bind(this, deal.dealID)}
                    >
                      Deal Buyers
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
        </tr>
      ));
    }

    if (!isEmpty(this.state.dealScheduleList)) {
      dealRowSchedule = this.state.dealScheduleList.map((deal, index) => (
        <tr key={Math.random()}>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.deal_id}</td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>{deal.quantity_remaining <= 0 ? "Sold Out" : ""}</td>
          )}
          <td>{moment(deal.executedOn).format("ll hh:mm A")}</td>
          <td>{deal.merchantName}</td>
          <td>{ReactHtmlParser(deal.dealText)}</td>
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td className="text-danger">
              <b>
                {localStorage.getItem("symbol")}
                {deal.revenue ? deal.revenue : "0.00"}
              </b>
            </td>
          )}
          <td>
            {!isEmpty(deal.startDateTime)
              ? moment(deal.startDateTime).format("ll hh:mm A") +
                " - " +
                moment(deal.expiryDateTime).format("ll hh:mm A")
              : "Not Scheduled"}
          </td>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.purchase_count}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.quantity_remaining}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.voucher_expiration_date}</td>
          )}

          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              {localStorage.getItem("symbol")}
              {parseFloat(deal.merchant_payables).toFixed(2)}
            </td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL("EDIT_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/editDeal/${deal.dealID}`
                        )
                      }
                    >
                      Edit Deal
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/edit`
                        )
                      }
                    >
                      Edit Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.deal_id + "/preview",
                      "deals-detail/"
                    )}
                  >
                    Preview Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.dealID,
                      "samplevoucher/"
                    )}
                  >
                    Preview Voucher
                  </MenuItem>
                  {/*aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/merchantDetails/${deal.uID}`)}>View Merchant</MenuItem>):("")*/}
                  <MenuItem
                    eventKey={Math.random()}
                    data-id={deal.dealID}
                    onClick={this.viewOrders}
                  >
                    Inventory
                  </MenuItem>
                  {aclUtil.checkACL("CLONE_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone`
                        )
                      }
                    >
                      Clone Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT_NON_EXECUTED") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone-non-execeuted`
                        )
                      }
                    >
                      Clone Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLOSE_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.dealID}
                      onClick={this.closeOffer}
                    >
                      Close Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.contractID}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "loadVoucherStatus"
                      )}
                    >
                      Load Voucher
                    </MenuItem>
                  )}
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={
                        this.loadVoucher.bind(
                          this,
                          deal.deal_id,
                          "UploadedVoucherStatus"
                        ) /*this.newWindow.bind(this, deal.dealID, 'uploaded-vouchers/')*/
                      }
                    >
                      Uploaded Voucher
                    </MenuItem>
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") && deal.shipable == "1" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "UploadCode"
                      )}
                    >
                      Upload Tracking Code
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {aclUtil.checkACL("DEAL_BUYER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.viewOffers.bind(this, deal.dealID)}
                    >
                      Deal Buyers
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
        </tr>
      ));
    }

    if (!isEmpty(this.state.dealPendingList)) {
      dealRowPending = this.state.dealPendingList.map((deal, index) => (
        <tr key={Math.random()}>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.deal_id}</td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>{deal.quantity_remaining <= 0 ? "Sold Out" : ""}</td>
          )}
          <td>{moment(deal.executedOn).format("ll hh:mm A")}</td>
          <td>{deal.merchantName}</td>
          <td>{ReactHtmlParser(deal.dealText)}</td>
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td className="text-danger">
              <b>
                {localStorage.getItem("symbol")}
                {deal.revenue ? deal.revenue : "0.00"}
              </b>
            </td>
          )}
          <td>
            {!isEmpty(deal.startDateTime)
              ? moment(deal.startDateTime).format("ll hh:mm A") +
                " - " +
                moment(deal.expiryDateTime).format("ll hh:mm A")
              : "Not Scheduled"}
          </td>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.purchase_count}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.quantity_remaining}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.voucher_expiration_date}</td>
          )}

          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              {localStorage.getItem("symbol")}
              {parseFloat(deal.merchant_payables).toFixed(2)}
            </td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL("EDIT_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/editDeal/${deal.dealID}`
                        )
                      }
                    >
                      Edit Deal
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/edit`
                        )
                      }
                    >
                      Edit Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.deal_id + "/preview",
                      "deals-detail/"
                    )}
                  >
                    Preview Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.dealID,
                      "samplevoucher/"
                    )}
                  >
                    Preview Voucher
                  </MenuItem>
                  {/*aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/merchantDetails/${deal.uID}`)}>View Merchant</MenuItem>):("")*/}
                  {aclUtil.checkACL("CLONE_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone`
                        )
                      }
                    >
                      Clone Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT_NON_EXECUTED") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone-non-execeuted`
                        )
                      }
                    >
                      Clone Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLOSE_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.dealID}
                      onClick={this.closeOffer}
                    >
                      Close Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.contractID}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "loadVoucherStatus"
                      )}
                    >
                      Load Voucher
                    </MenuItem>
                  )}
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={
                        this.loadVoucher.bind(
                          this,
                          deal.deal_id,
                          "UploadedVoucherStatus"
                        ) /*this.newWindow.bind(this, deal.dealID, 'uploaded-vouchers/')*/
                      }
                    >
                      Uploaded Voucher
                    </MenuItem>
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") && deal.shipable == "1" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "UploadCode"
                      )}
                    >
                      Upload Tracking Code
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {aclUtil.checkACL("DEAL_BUYER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.viewOffers.bind(this, deal.dealID)}
                    >
                      Deal Buyers
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
        </tr>
      ));
    }

    if (!isEmpty(this.state.dealList)) {
      dealRow = this.state.dealList.map((deal, index) => (
        <tr key={Math.random()}>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.deal_id}</td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>{deal.quantity_remaining <= 0 ? "Sold Out" : ""}</td>
          )}
          <td>{moment(deal.executedOn).format("ll hh:mm A")}</td>
          <td>{deal.merchantName}</td>
          <td>{ReactHtmlParser(deal.dealText)}</td>
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td className="text-danger">
              <b>
                {localStorage.getItem("symbol")}
                {deal.revenue ? deal.revenue : "0.00"}
              </b>
            </td>
          )}
          <td>
            {!isEmpty(deal.startDateTime)
              ? moment(deal.startDateTime).format("ll hh:mm A") +
                " - " +
                moment(deal.expiryDateTime).format("ll hh:mm A")
              : "Not Scheduled"}
          </td>
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.purchase_count}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.quantity_remaining}</td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>{deal.voucher_expiration_date}</td>
          )}

          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              {localStorage.getItem("symbol")}
              {parseFloat(deal.merchant_payables).toFixed(2)}
            </td>
          )}
          {localStorage.getItem("userTypeName") !== "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  {aclUtil.checkACL("EDIT_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/editDeal/${deal.dealID}`
                        )
                      }
                    >
                      Edit Deal
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("EDIT_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/edit`
                        )
                      }
                    >
                      Edit Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.deal_id + "/preview",
                      "deals-detail/"
                    )}
                  >
                    Preview Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.newWindow.bind(
                      this,
                      deal.dealID,
                      "samplevoucher/"
                    )}
                  >
                    Preview Voucher
                  </MenuItem>
                  {/*aclUtil.checkACL('VIEW_LEAD') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/merchantDetails/${deal.uID}`)}>View Merchant</MenuItem>):("")*/}
                  <MenuItem
                    eventKey={Math.random()}
                    data-id={deal.dealID}
                    onClick={this.viewOrders}
                  >
                    Inventory
                  </MenuItem>
                  {aclUtil.checkACL("CLONE_CONTRACT") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone`
                        )
                      }
                    >
                      Clone Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLONE_CONTRACT_NON_EXECUTED") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={() =>
                        this.context.router.history.push(
                          `/addContract/${deal.contractID}/clone-non-execeuted`
                        )
                      }
                    >
                      Clone Contract
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {aclUtil.checkACL("CLOSE_OFFER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.dealID}
                      onClick={this.closeOffer}
                    >
                      Close Offer
                    </MenuItem>
                  ) : (
                    ""
                  )}
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      data-id={deal.contractID}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "loadVoucherStatus"
                      )}
                    >
                      Load Voucher
                    </MenuItem>
                  )}
                  {deal.useExternalCoupon == 1 && (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={
                        this.loadVoucher.bind(
                          this,
                          deal.deal_id,
                          "UploadedVoucherStatus"
                        ) /*this.newWindow.bind(this, deal.dealID, 'uploaded-vouchers/')*/
                      }
                    >
                      Uploaded Voucher
                    </MenuItem>
                  )}
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewExportOrders.bind(this, deal.dealID)}
                  >
                    Transactions
                  </MenuItem>
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewOffers.bind(this, deal.dealID)}
                  >
                    Deal Buyers
                  </MenuItem>
                  {aclUtil.checkACL("EDIT_CONTRACT") && deal.shipable == "1" ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.loadVoucher.bind(
                        this,
                        deal.deal_id,
                        "UploadCode"
                      )}
                    >
                      Upload Tracking Code
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
          {localStorage.getItem("userTypeName") == "merchant" && (
            <td>
              <ButtonGroup>
                <DropdownButton title="Action" id="bg-nested-dropdown">
                  <MenuItem
                    eventKey={Math.random()}
                    onClick={this.viewAllDeals.bind(this, deal.dealID)}
                  >
                    View Child Deal
                  </MenuItem>
                  {aclUtil.checkACL("DEAL_BUYER") ? (
                    <MenuItem
                      eventKey={Math.random()}
                      onClick={this.viewOffers.bind(this, deal.dealID)}
                    >
                      Deal Buyers
                    </MenuItem>
                  ) : (
                    ""
                  )}
                </DropdownButton>
              </ButtonGroup>
            </td>
          )}
        </tr>
      ));
    }
    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1"></div>
              <div className="dot2"></div>
            </div>
          </div>
        ) : (
          ""
        )}
        <CSVLink
          data={this.state.downloadData}
          filename={
            this.state.merchantName + "-" + this.state.offerName + ".csv"
          }
          id="downloadData"
        />
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 list-page">
          <div className="row">
            {localStorage.getItem("userTypeName") !== "merchant" && (
              <div className="col-xs-12">
                <BreadcrumbComponent
                  path={this.state.path}
                  links={this.state.links}
                  context={this.context}
                />
              </div>
            )}
          </div>
          <div className="panel">
            <header className="panel-heading panel-heading-index">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <h4>Deal/Offer List</h4>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <FormGroup>
                    <FormControl
                      componentClass="select"
                      value={this.state.default_city}
                      placeholder="select"
                      name="default_city"
                      onChange={this.setDefaultCity}
                    >
                      {localStorage.getItem("userTypeName") !=
                        "salesmanager" && (
                        <option value="">Choose Region/City</option>
                      )}
                      {this.state.cityList &&
                        this.state.cityList.map((data, index) => (
                          <optgroup key={"hcity" + index} label={data.country}>
                            {data.cities &&
                              data.cities.map((city, index) => (
                                <option
                                  key={"hcityval" + index}
                                  value={city.cityID}
                                >
                                  {city.title}
                                </option>
                              ))}
                          </optgroup>
                        ))}
                    </FormControl>
                  </FormGroup>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl
                        type="text"
                        name="search"
                        onKeyUp={this.handleSearch}
                      />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
                <div className="col-lg-2 col-md-4 col-sm-12">
                  <DropdownButton
                    bsSize="small"
                    bsStyle="default"
                    title={this.state.selectedOption}
                    onSelect={this.handleSelect}
                    id="0"
                  >
                    {options.map((opt, i) => (
                      <MenuItem key={i} eventKey={i}>
                        {opt}
                      </MenuItem>
                    ))}
                  </DropdownButton>
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.messageShow && this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}
              <Row>
                <Col xs={12} md={12}>
                  <Tabs
                    activeKey={this.state.key}
                    onSelect={this.handleTabs}
                    id="controlled-tab-example"
                  >
                    <Tab eventKey={1} title="Current Offers">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            {localStorage.getItem("userTypeName") ==
                              "merchant" && <th>Offer ID</th>}
                            {localStorage.getItem("userTypeName") !==
                              "merchant" && (
                              <th
                                onClick={this.sorting.bind(
                                  this,
                                  "skuCode",
                                  this.state.skuCodesortOrder
                                )}
                              >
                                Sold Out
                              </th>
                            )}
                            <th>Executed On</th>
                            <th
                              onClick={this.sorting.bind(
                                this,
                                "merchantName",
                                this.state.merchantNamesortOrder
                              )}
                            >
                              Merchant Name{" "}
                              <i className={this.state.merchantNameIconCur} />
                            </th>
                            <th
                              onClick={this.sorting.bind(
                                this,
                                "mainDealText",
                                this.state.dealTextsortOrder
                              )}
                            >
                              Offer <i className={this.state.dealTextIconCur} />
                            </th>
                            {localStorage.getItem("userTypeName") !==
                              "merchant" && <th>Revenue</th>}
                            <th>Schedule</th>
                            {localStorage.getItem("userTypeName") ==
                              "merchant" && <th>Number Sold</th>}
                            {localStorage.getItem("userTypeName") ==
                              "merchant" && <th>Number Remaining</th>}
                            {localStorage.getItem("userTypeName") ==
                              "merchant" && <th>Voucher Expiration Date</th>}
                            {localStorage.getItem("userTypeName") ==
                              "merchant" && <th>Merchant Payable Amount</th>}
                            {localStorage.getItem("userTypeName") !==
                              "merchant" && <th>Actions</th>}
                            {localStorage.getItem("userTypeName") ==
                              "merchant" && <th>Action</th>}
                          </tr>
                        </thead>
                        <tbody>{dealRow}</tbody>
                      </table>

                      <div className="text-center">
                        <Pagination
                          total={totalRecords}
                          limit={perPage}
                          pageCount={5}
                          currentPage={currentPage}
                        >
                          {({
                            pages,
                            currentPage,
                            hasNextPage,
                            hasPreviousPage,
                            previousPage,
                            nextPage,
                            totalPages,
                            getPageItemProps,
                          }) => (
                            <div className="pagination">
                              <button
                                className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: 1,
                                  onPageChange: this.handlePageChange,
                                })}
                              >
                                first
                              </button>

                              {hasPreviousPage && (
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: previousPage,
                                    onPageChange: this.handlePageChange,
                                  })}
                                >
                                  {"<"}
                                </button>
                              )}

                              {pages.map((page) => {
                                let activePage = null;
                                if (currentPage === page) {
                                  activePage = {
                                    backgroundColor: "#ccc",
                                    color: "#666",
                                  };
                                }
                                return (
                                  <button
                                    className="btn btn-default"
                                    key={page}
                                    style={activePage}
                                    {...getPageItemProps({
                                      pageValue: page,
                                      onPageChange: this.handlePageChange,
                                    })}
                                  >
                                    {page}
                                  </button>
                                );
                              })}

                              {hasNextPage && (
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: nextPage,
                                    onPageChange: this.handlePageChange,
                                  })}
                                >
                                  {">"}
                                </button>
                              )}

                              <button
                                className="btn btn-default"
                                {...getPageItemProps({
                                  pageValue: totalPages,
                                  onPageChange: this.handlePageChange,
                                })}
                              >
                                last
                              </button>
                            </div>
                          )}
                        </Pagination>
                      </div>
                    </Tab>
                    {aclUtil.checkACL("FUTURE_CONTRACT") ||
                    localStorage.getItem("userTypeName") == "merchant" ? (
                      <Tab eventKey={2} title="Upcoming Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Offer ID</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && (
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "skuCode",
                                    this.state.skuCodesortOrder
                                  )}
                                >
                                  Sold Out
                                </th>
                              )}
                              <th>Executed On</th>
                              <th
                                onClick={this.upcomingSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIconUp} />
                              </th>
                              <th
                                onClick={this.upcomingSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer{" "}
                                <i className={this.state.dealTextIconUp} />
                              </th>
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Revenue</th>}
                              <th>Schedule</th>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Sold</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Remaining</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Voucher Expiration Date</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Merchant Payable Amount</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Actions</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>{dealRowUnschedule}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={upcomingTotalRecords}
                            limit={upcomingPerPage}
                            pageCount={upcomingPageCount}
                            currentPage={upcomingCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps,
                            }) => (
                              <div className="pagination">
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handleUpcomingPageChange,
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange:
                                        this.handleUpcomingPageChange,
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map((page) => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666",
                                    };
                                  }
                                  return (
                                    <button
                                      className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange:
                                          this.handleUpcomingPageChange,
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange:
                                        this.handleUpcomingPageChange,
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handleUpcomingPageChange,
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                        </div>
                      </Tab>
                    ) : (
                      ""
                    )}
                    {aclUtil.checkACL("SCHEDULE_CONTRACT") ||
                    localStorage.getItem("userTypeName") == "merchant" ? (
                      <Tab eventKey={6} title="Scheduled Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Offer ID</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && (
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "skuCode",
                                    this.state.skuCodesortOrder
                                  )}
                                >
                                  Sold Out
                                </th>
                              )}
                              <th>Executed On</th>
                              <th
                                onClick={this.scheduleSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIconSch} />
                              </th>
                              <th
                                onClick={this.scheduleSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer{" "}
                                <i className={this.state.dealTextIconSch} />
                              </th>
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Revenue</th>}
                              <th>Schedule</th>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Sold</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Remaining</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Voucher Expiration Date</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Merchant Payable Amount</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Actions</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>{dealRowSchedule}</tbody>
                        </table>
                        <div className="text-center">
                          <Pagination
                            total={scheduleTotalRecords}
                            limit={schedulePerPage}
                            pageCount={schedulePageCount}
                            currentPage={scheduleCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps,
                            }) => (
                              <div className="pagination">
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handleSchedulePageChange,
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange:
                                        this.handleSchedulePageChange,
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map((page) => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666",
                                    };
                                  }
                                  return (
                                    <button
                                      className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange:
                                          this.handleSchedulePageChange,
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange:
                                        this.handleSchedulePageChange,
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handleSchedulePageChange,
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                        </div>
                      </Tab>
                    ) : (
                      ""
                    )}
                    {aclUtil.checkACL("PENDING_CONTRACT") ||
                    localStorage.getItem("userTypeName") == "merchant" ? (
                      <Tab eventKey={4} title="Pending Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Offer ID</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && (
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "skuCode",
                                    this.state.skuCodesortOrder
                                  )}
                                >
                                  Sold Out
                                </th>
                              )}
                              <th>Executed On</th>
                              <th
                                onClick={this.pendingSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIconPen} />
                              </th>
                              <th
                                onClick={this.pendingSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer{" "}
                                <i className={this.state.dealTextIconPen} />
                              </th>
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Revenue</th>}
                              <th>Schedule</th>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Sold</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Remaining</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Voucher Expiration Date</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Merchant Payable Amount</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Actions</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>{dealRowPending}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={pendingTotalRecords}
                            limit={pendingPerPage}
                            pageCount={pendingPageCount}
                            currentPage={pendingCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps,
                            }) => (
                              <div className="pagination">
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handlePendingPageChange,
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange:
                                        this.handlePendingPageChange,
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map((page) => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666",
                                    };
                                  }
                                  return (
                                    <button
                                      className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange:
                                          this.handlePendingPageChange,
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange:
                                        this.handlePendingPageChange,
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handlePendingPageChange,
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                        </div>
                      </Tab>
                    ) : (
                      ""
                    )}
                    {aclUtil.checkACL("PAST_CONTRACT") ||
                    localStorage.getItem("userTypeName") == "merchant" ? (
                      <Tab eventKey={5} title="Past Offers">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Offer ID</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && (
                                <th
                                  onClick={this.sorting.bind(
                                    this,
                                    "skuCode",
                                    this.state.skuCodesortOrder
                                  )}
                                >
                                  Sold Out
                                </th>
                              )}
                              <th>Executed On</th>
                              <th
                                onClick={this.pastSorting.bind(
                                  this,
                                  "merchantName",
                                  this.state.merchantNamesortOrder
                                )}
                              >
                                Merchant Name{" "}
                                <i className={this.state.merchantNameIconPas} />
                              </th>
                              <th
                                onClick={this.pastSorting.bind(
                                  this,
                                  "mainDealText",
                                  this.state.dealTextsortOrder
                                )}
                              >
                                Offer{" "}
                                <i className={this.state.dealTextIconPas} />
                              </th>
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Revenue</th>}
                              <th>Schedule</th>
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Sold</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Number Remaining</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Voucher Expiration Date</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Merchant Payable Amount</th>}
                              {localStorage.getItem("userTypeName") !==
                                "merchant" && <th>Actions</th>}
                              {localStorage.getItem("userTypeName") ==
                                "merchant" && <th>Action</th>}
                            </tr>
                          </thead>
                          <tbody>{dealRowPast}</tbody>
                        </table>

                        <div className="text-center">
                          <Pagination
                            total={pastTotalRecords}
                            limit={pastPerPage}
                            pageCount={pastPageCount}
                            currentPage={pastCurrentPage}
                          >
                            {({
                              pages,
                              currentPage,
                              hasNextPage,
                              hasPreviousPage,
                              previousPage,
                              nextPage,
                              totalPages,
                              getPageItemProps,
                            }) => (
                              <div className="pagination">
                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: 1,
                                    onPageChange: this.handlePastPageChange,
                                  })}
                                >
                                  first
                                </button>

                                {hasPreviousPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: previousPage,
                                      onPageChange: this.handlePageChange,
                                    })}
                                  >
                                    {"<"}
                                  </button>
                                )}

                                {pages.map((page) => {
                                  let activePage = null;
                                  if (currentPage === page) {
                                    activePage = {
                                      backgroundColor: "#ccc",
                                      color: "#666",
                                    };
                                  }
                                  return (
                                    <button
                                      className="btn btn-default"
                                      key={page}
                                      style={activePage}
                                      {...getPageItemProps({
                                        pageValue: page,
                                        onPageChange: this.handlePastPageChange,
                                      })}
                                    >
                                      {page}
                                    </button>
                                  );
                                })}

                                {hasNextPage && (
                                  <button
                                    className="btn btn-default"
                                    {...getPageItemProps({
                                      pageValue: nextPage,
                                      onPageChange: this.handlePastPageChange,
                                    })}
                                  >
                                    {">"}
                                  </button>
                                )}

                                <button
                                  className="btn btn-default"
                                  {...getPageItemProps({
                                    pageValue: totalPages,
                                    onPageChange: this.handlePastPageChange,
                                  })}
                                >
                                  last
                                </button>
                              </div>
                            )}
                          </Pagination>
                        </div>
                      </Tab>
                    ) : (
                      ""
                    )}
                  </Tabs>
                </Col>
              </Row>
              <div className="row">
                <div className="col-lg-12"></div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>

        <Modal
          show={this.state.show}
          onHide={this.handleClose.bind(this)}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Orders Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover">
              {this.state.viewMainOrders && (
                <React.Fragment>
                  <tbody>
                    <tr>
                      <td>
                        Overall Quantity{" "}
                        <Button
                          bsSize="xsmall"
                          data-id={this.state.viewMainOrders.dealID}
                          onClick={this.setOverallQuantity}
                          bsStyle="success"
                        >
                          Update Quantity
                        </Button>
                      </td>
                      <td>{this.state.viewMainOrders.max_overall}</td>
                    </tr>
                    {this.state.OverallquantityID ==
                      this.state.viewMainOrders.dealID && (
                      <tr key={this.state.viewMainOrders.dealID + "o"}>
                        <td>Set Quantity</td>
                        <td>
                          <FormControl
                            type="number"
                            value={this.state.updateOverallqty}
                            name="updateOverallqty"
                            placeholder="Enter Quantity"
                            onChange={this.handleChange}
                            style={{
                              borderColor: this.state.updateOverallqtyError,
                            }}
                          />
                        </td>
                        <td>
                          <Button
                            bsSize="xsmall"
                            data-id={this.state.viewMainOrders.dealID}
                            onClick={this.updateOverallQty}
                            bsStyle="success"
                          >
                            {this.state.updateOverallkey}
                          </Button>
                        </td>
                        <td>
                          <Button
                            bsSize="xsmall"
                            onClick={this.cancelOverallQuantity}
                            bsStyle="danger"
                          >
                            Cancel
                          </Button>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </React.Fragment>
              )}
            </table>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Available</th>
                  <th>Sold</th>
                  <th>Left</th>
                </tr>
              </thead>
              <tbody>
                {this.state.viewOrders &&
                  this.state.viewOrders.map((data, key) => (
                    <React.Fragment>
                      <tr key={Math.random()}>
                        <td>
                          {ReactHtmlParser(data.dealText)}{" "}
                          {data.total != "" ? (
                            <Button
                              bsSize="xsmall"
                              data-id={data.dealID}
                              onClick={this.setQuantity}
                              bsStyle="success"
                            >
                              Update Quantity
                            </Button>
                          ) : (
                            ""
                          )}
                        </td>
                        <td>{data.total}</td>
                        <td>{data.quantity}</td>
                        <td>
                          {data.total - data.quantity >= 0
                            ? data.total - data.quantity
                            : 0}
                        </td>
                      </tr>
                      {this.state.quantityID == data.dealID && (
                        <tr key={data.dealID + key + "s"}>
                          <td>Set Quantity</td>
                          <td>
                            <FormControl
                              type="number"
                              value={this.state.updateqty}
                              name="updateqty"
                              placeholder="Enter Quantity"
                              onChange={this.handleChange}
                              style={{ borderColor: this.state.updateqtyError }}
                            />
                          </td>
                          <td>
                            <Button
                              bsSize="xsmall"
                              data-id={data.dealID}
                              onClick={this.updateQty}
                              bsStyle="success"
                            >
                              {this.state.updatekey}
                            </Button>
                          </td>
                          <td>
                            <Button
                              bsSize="xsmall"
                              onClick={this.cancelQuantity}
                              bsStyle="danger"
                            >
                              Cancel
                            </Button>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.loadVoucherStatus}
          onHide={this.loadVoucherClose.bind(this)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Load External Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ControlLabel>Select Offer</ControlLabel>
            <FormGroup controlId="formcontractID">
              <FormControl
                componentClass="select"
                value={this.state.contractID}
                onChange={this.handleChange}
                name="contractID"
              >
                {this.state.ContractList &&
                  this.state.ContractList.map((data, key) => (
                    <option value={data.contractID}>
                      {ReactHtmlParser(data.dealText)}
                    </option>
                  ))}
              </FormControl>
            </FormGroup>
            <FormGroup controlId="formfile">
              <FormControl
                type="file"
                id="file"
                onChange={this.handleFormData}
              />
            </FormGroup>
            <Checkbox name="includeQr" onChange={(e) => this.checkboxChange(e)}>
              Include redemption URL in QR Code.
            </Checkbox>
          </Modal.Body>
          <Modal.Footer>
            <CSVLink
              data={this.state.csvData}
              filename={"exportVoucher.csv"}
              className="btn btn-default pull-left"
            >
              Download Demo File
            </CSVLink>
            <Button onClick={this.uploadVoucher.bind(this)} bsStyle="success">
              {this.state.uploadButton}
            </Button>
            <Button bsStyle="danger" onClick={this.loadVoucherClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.UploadedVoucherStatus}
          onHide={this.loadVoucherClose.bind(this)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Load External Voucher</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {this.state.ContractList &&
                  this.state.ContractList.map((data, key) => (
                    <React.Fragment>
                      <tr key={Math.random()}>
                        <td>{ReactHtmlParser(data.dealText)}</td>
                        <td>
                          <Button
                            bsSize="small"
                            onClick={this.newWindow.bind(
                              this,
                              data.dealID,
                              "uploaded-vouchers/"
                            )}
                            bsStyle="success"
                          >
                            Uploaded Voucher
                          </Button>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.loadVoucherClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.UploadCode}
          onHide={this.loadVoucherClose.bind(this)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Tracking Code</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ControlLabel>Select Offer</ControlLabel>
            <FormGroup controlId="formdeal_id">
              <FormControl
                componentClass="select"
                value={this.state.dealID}
                onChange={this.handleChange}
                name="dealID"
              >
                {this.state.ContractList &&
                  this.state.ContractList.map((data, key) => (
                    <option value={data.dealID}>
                      {ReactHtmlParser(data.dealText)}
                    </option>
                  ))}
              </FormControl>
            </FormGroup>
            <FormGroup controlId="formfile">
              <FormControl
                type="file"
                id="file"
                onChange={this.handleFormData}
              />
            </FormGroup>
            <FormGroup controlId="shippingEmail">
              <Checkbox name="shippingEmail" onChange={this.shippingEmail}>
                Send Shipping Confirmation Email To Customers.
              </Checkbox>
            </FormGroup>
          </Modal.Body>
          <Modal.Footer>
            <CSVLink
              data={this.state.csvCodeData}
              filename={"TrackingCode.csv"}
              className="btn btn-default pull-left"
            >
              Download Demo File
            </CSVLink>
            <Button onClick={this.uploadCode.bind(this)} bsStyle="success">
              {this.state.uploadButton}
            </Button>
            <Button bsStyle="danger" onClick={this.loadVoucherClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.dealShow}
          bsSize="large"
          onHide={this.handleDealClose.bind(this)}
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>Child Deals</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-hover table-responsive">
              <thead>
                <tr>
                  <th>Sold Out</th>
                  <th>Merchant Name</th>
                  <th>Offer</th>
                  {localStorage.getItem("userTypeName") !== "merchant" && (
                    <th>Revenue</th>
                  )}
                  <th>Schedule</th>
                  {localStorage.getItem("userTypeName") == "merchant" && (
                    <th>Number Sold</th>
                  )}
                  {localStorage.getItem("userTypeName") == "merchant" && (
                    <th>Number Remaining</th>
                  )}
                  {localStorage.getItem("userTypeName") == "merchant" && (
                    <th>Voucher Expiration Date</th>
                  )}
                  {localStorage.getItem("userTypeName") == "merchant" && (
                    <th>Merchant Payable Amount</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.child_deals) ? (
                  this.state.child_deals.map((deal, index) => (
                    <tr>
                      <td>{deal.quantity_remaining <= 0 ? "Sold Out" : ""}</td>
                      <td>{deal.merchantName}</td>
                      <td>{ReactHtmlParser(deal.dealText)}</td>
                      {localStorage.getItem("userTypeName") !== "merchant" && (
                        <td className="text-danger">
                          <b>
                            {localStorage.getItem("symbol")}
                            {deal.revenue ? deal.revenue : "0.00"}
                          </b>
                        </td>
                      )}
                      <td>
                        {!isEmpty(deal.startDateTime)
                          ? deal.startDateTime + "-" + deal.expiryDateTime
                          : "Not Scheduled"}
                      </td>
                      {localStorage.getItem("userTypeName") == "merchant" && (
                        <td>{deal.purchase_count}</td>
                      )}
                      {localStorage.getItem("userTypeName") == "merchant" && (
                        <td>{deal.quantity_remaining}</td>
                      )}
                      {localStorage.getItem("userTypeName") == "merchant" && (
                        <td>{deal.voucher_expiration_date}</td>
                      )}
                      {localStorage.getItem("userTypeName") == "merchant" && (
                        <td>
                          {localStorage.getItem("symbol")}
                          {parseFloat(deal.merchant_payables).toFixed(2)}
                        </td>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={10}></td>
                  </tr>
                )}
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle="danger" onClick={this.handleDealClose.bind(this)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

DealtList.propTypes = {
  getDealList: PropTypes.func.isRequired,
  getDealPending: PropTypes.func.isRequired,
  getDealUpcoming: PropTypes.func.isRequired,
  getDealPast: PropTypes.func.isRequired,
  deleteDeal: PropTypes.func.isRequired,
  getOrderDeatil: PropTypes.func.isRequired,
  updateQuantity: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  dealList: state.dealReducer.dealList,
  dealPendingList: state.dealReducer.dealPendingList,
  dealUpcomingList: state.dealReducer.dealUpcomingList,
  dealPastList: state.dealReducer.dealPastList,
  dealDeleted: state.dealReducer.dealDeleted,
  ChildDeals: state.dealReducer.ChildDeals,
  error: state.contractReducer.error,
  alertType: state.alertsReducer.alertType,
  orderData: state.dealReducer.orderData,
  message: state.alertsReducer.message,
  closeStatus: state.dealReducer.closeStatus,
  voucherStatus: state.dealReducer.voucherStatus,
  dealError: state.dealReducer.error,
  dealScheduleList: state.dealReducer.dealScheduleList,
  quantityStatus: state.dealReducer.quantityStatus,
  cityList: state.frontReducer.cityList,
  transaction: state.reportReducer.transaction,
  exportList: state.voucherReducer.exportList,
  ContractList: state.dealReducer.ContractList,
  tracknigResponse: state.voucherReducer.tracknigResponse,
});

export default withRouter(
  connect(mapStateToProps, {
    getDealList,
    getDealPending,
    getDealUpcoming,
    getDealPast,
    deleteDeal,
    renderAlert,
    getOrderDeatil,
    clearAlert,
    confirmClose,
    uploadExternalVoucher,
    getDealSchedule,
    updateQuantity,
    getChildDeals,
    getDealContract,
    getSiteCity,
    transactionReport,
    export_PurchaserList,
    export_PurchaserArchiveList,
    upload_TrackingNumbers,
  })(DealtList)
);


// WEBPACK FOOTER //
// ./src/app/views/admin/deal/DealList.js